import { MaintenanceConfig } from "../api/models";
import { parseBackendDate } from "./helpers";

export const defaultMaintenanceConfig: MaintenanceConfig = {
  display_maintenance_banner: false,
  maintenance_banner_message: "The system will undergo maintenance soon.",
  display_maintenance_page: false,
  schedule_maintenance_page: false,
  scheduled_maintenance_start_time: "",
  scheduled_maintenance_end_time: "",
  maintenance_page_message:
    "The system is currently undergoing maintenance. Please check back later.",
};

const isScheduleWindowActive = (config: MaintenanceConfig): boolean => {
  if (!config.schedule_maintenance_page) {
    return false;
  }

  const start = parseBackendDate(config.scheduled_maintenance_start_time);
  const end = parseBackendDate(config.scheduled_maintenance_end_time);

  if (!start || !end) {
    return false;
  }

  const now = new Date();
  return now >= start && now <= end;
};

export const shouldShowMaintenancePage = (
  config: MaintenanceConfig,
): boolean => {
  return config.display_maintenance_page || isScheduleWindowActive(config);
};

export const shouldShowMaintenanceBanner = (
  config: MaintenanceConfig,
): boolean => {
  return config.display_maintenance_banner;
};
